'use client'
import PartnerPreview from "@/app/components/pages/our-partners/PartnerPreview";
import styles from '@/app/styles/components/pages/our-partners/our-partner-list.module.scss'
import Pagination from "@/app/components/common/Pagination";
import React from "react";
import {useState} from "react";
import {getPartners} from "@/app/services/PartnerService";
import {useRouter} from "next/navigation";

const OurPartnersList = ({pageData, route}) => {
    const [page, setPage] = useState(pageData?.page ? pageData?.page : 1)
    const router = useRouter()

    const onPageChanged = (pageNumber) => {
        setPage(pageNumber)

        fetchData({
            page: pageNumber
        })
    }

    const fetchData = (params) => {
        const urlParams = new URLSearchParams(params).toString();
        router.push(route + '?' + urlParams, { shallow: false });
    }

    const renderPartners = (partners) => {

        if (!partners) {
            return ''
        }

        let result = []

        for (let partner of partners) {
            result.push(<PartnerPreview key={'partner-' + partner.id} partner={partner}/>)
        }

        return result
    }


    return <div className={'container'}>
        <div className={styles.partnersContainer}>
            {renderPartners(pageData.data)}
        </div>

        <Pagination
            items={pageData.total}
            pageSize={10}
            currentPage={page}
            onPageChange={onPageChanged}
        />
    </div>
}

export default OurPartnersList